import { InfoWindow, Marker } from '@react-google-maps/api';
import { memo, useState, useEffect } from 'react'
import { useTheme } from '@mui/material';

const infoWindowStyles = `
.gm-style-iw-c {
    padding: 0 !important;
    border-radius: 10px !important;
    overflow: visible !important;
    box-shadow: 0 4px 20px rgba(0,0,0,0.15) !important;
}
.gm-style-iw-d {
    overflow: hidden !important;
    max-height: none !important;
}
.gm-style-iw-tc::after {
    background: #fff !important;
}
.gm-ui-hover-effect {
    top: 2px !important;
    right: 2px !important;
}
`;

const infoWindowDarkStyles = `
.gm-style-iw-c {
    padding: 0 !important;
    border-radius: 10px !important;
    overflow: visible !important;
    background: #1F2A40 !important;
    box-shadow: 0 4px 20px rgba(0,0,0,0.5) !important;
    border: 1px solid #3d4a62 !important;
}
.gm-style-iw-d {
    overflow: hidden !important;
    max-height: none !important;
}
.gm-style-iw-tc::after {
    background: #1F2A40 !important;
}
.gm-ui-hover-effect > span {
    background-color: #b0bec5 !important;
}
.gm-ui-hover-effect {
    top: 2px !important;
    right: 2px !important;
}
`;

function MarkerClienteDash({
    coordenadas,
    item,
    ...defaultProps
}) {
    const theme = useTheme();
    const isDarkMode = theme.palette.mode === 'dark';
    const [isVisible, setIsVisible] = useState(false);
    const [colorIcon, setcolorIcon] = useState('/img/antena2.png')
    useEffect(() => {
        switch (item?.tipoTecnologia) {
            case 'FO':
                setcolorIcon('/img/fibra-optica.png')
                break;
            default:
                setcolorIcon('/img/antena2.png')
                break;
        }
    }, [item])
    return (
        <Marker
            {...defaultProps}
            position={coordenadas}
            onClick={()=>setIsVisible(!isVisible)}
            icon={{
                url: colorIcon,
                scaledSize: {
                    width:50,
                    height:50,
                }
            }}
        >
            { isVisible && (
                <>
                    <style>{isDarkMode ? infoWindowDarkStyles : infoWindowStyles}</style>
                    <InfoWindow
                        className="card"
                        position={coordenadas}
                        onCloseClick={()=>{setIsVisible(!isVisible)}}
                    >
                        <div style={{
                            backgroundColor: isDarkMode ? '#1F2A40' : '#fff',
                            color: isDarkMode ? '#e0e0e0' : '#000',
                            padding: '14px 16px',
                            borderRadius: '10px',
                            minWidth: '190px',
                            fontFamily: "'Segoe UI', Roboto, sans-serif",
                        }}>
                            <div style={{
                                display: 'inline-block',
                                background: item?.cuenta
                                    ? (isDarkMode ? 'linear-gradient(135deg, #1565c0, #1e88e5)' : 'linear-gradient(135deg, #1e88e5, #42a5f5)')
                                    : (isDarkMode ? 'linear-gradient(135deg, #e65100, #f57c00)' : 'linear-gradient(135deg, #f57c00, #ffb74d)'),
                                color: '#fff',
                                padding: '3px 10px',
                                borderRadius: '4px',
                                fontWeight: 600,
                                fontSize: '10px',
                                letterSpacing: '0.5px',
                                marginBottom: '8px',
                            }}>
                                {item?.cuenta ? 'SERVICIO' : 'PRE-SERVICIO'}
                            </div>
                            <div style={{
                                fontSize: '15px',
                                fontWeight: 700,
                                color: isDarkMode ? '#e0e0e0' : '#1a1a2e',
                                marginBottom: '8px',
                                paddingBottom: '8px',
                                borderBottom: `1px solid ${isDarkMode ? '#3d4a62' : '#e0e0e0'}`,
                            }}>
                                {`#${item?.servicio || ''}`}
                            </div>
                            <div style={{
                                display: 'flex',
                                flexDirection: 'column',
                                gap: '5px',
                            }}>
                                <div style={{
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    alignItems: 'center',
                                    fontSize: '12px',
                                }}>
                                    <span style={{color: isDarkMode ? '#8899a6' : '#666', fontWeight: 500}}>Cliente</span>
                                    <span style={{color: isDarkMode ? '#e0e0e0' : '#1a1a2e', fontWeight: 600, maxWidth: '140px', textAlign: 'right'}}>
                                        {item?.nombreCliente || '-'}
                                    </span>
                                </div>
                                <div style={{
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    alignItems: 'center',
                                    fontSize: '12px',
                                }}>
                                    <span style={{color: isDarkMode ? '#8899a6' : '#666', fontWeight: 500}}>Plan</span>
                                    <span style={{
                                        color: isDarkMode ? '#e0e0e0' : '#1a1a2e',
                                        fontWeight: 600,
                                        backgroundColor: isDarkMode ? '#2d3a52' : '#f0f0f0',
                                        padding: '2px 8px',
                                        borderRadius: '4px',
                                        fontSize: '11px',
                                    }}>
                                        {item?.nombrePlan || '-'}
                                    </span>
                                </div>
                                <div style={{
                                    display: 'flex',
                                    justifyContent: 'center',
                                    fontSize: '10px',
                                    color: isDarkMode ? '#5a6a7e' : '#999',
                                    marginTop: '4px',
                                    paddingTop: '6px',
                                    borderTop: `1px solid ${isDarkMode ? '#3d4a62' : '#f0f0f0'}`,
                                }}>
                                    {`${item?.latitud || ''}, ${item?.longitud || ''}`}
                                </div>
                            </div>
                        </div>
                    </InfoWindow>
                </>
            )}
        </Marker>
    );
}

export default memo(MarkerClienteDash);
